import { api } from 'src/boot/axios.js';
import ApiError from './error';

const OrderService = {
  get({ orderId }) {
    return api.get(`order/${orderId}`).catch((e) => {
      throw new ApiError(e);
    });
  },
  post(order) {
    return api.post('order', order).catch((e) => {
      throw new ApiError(e);
    });
  },
};

export default OrderService;
